(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/vi", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/vi"] = factory();
	else
		root["i18n/vi"] = factory();
})(window, function() {
return 